function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.783 3.605a1 1 0 0 1 .646 1.162l-.032.112-3.283 9.394L5.202 8.91l.12-.09c6.18-3.973 12.041-4.365 17.42-1.11 7.708 4.663 11.262 13.667 10.732 26.856a1 1 0 1 1-1.999-.08c.505-12.53-2.774-20.833-9.769-25.066-4.59-2.776-9.523-2.51-14.955.862l-.297.187.008-.005-6.025 5.309 9.732-2.073a1 1 0 0 1 1.156.657l.03.113a1 1 0 0 1-.656 1.156l-.113.03-13.466 2.869-1.739.37.587-1.678L.509 4.219a1 1 0 0 1 1.274-.614z",
  fill: "#171719",
  fillRule: "nonzero"
});
function SvgPath4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath4);
export default __webpack_public_path__ + "static/media/path-4.4f518ce659e6681ee342b99ba3af8a87.svg";
export { ForwardRef as ReactComponent };